/* globals document window fetch FormData */

import 'isomorphic-fetch';

const API_ROOT = '/api/v1/';

const getCsrf = () => {
  const value = `; ${document.cookie}`;
  const parts = value.split('; csrftoken=');
  if (parts.length === 2) return parts.pop().split(';').shift();
  return null;
};

const processArgs = (args) => {
  const queries = [];
  Object.keys(args).forEach((arg) => {
    const param = args[arg];
    let str = param;
    if (param && param.constructor === Array) {
      str = param.join(',');
    }
    queries.push(`${arg}=${str}`);
  });
  return `?${queries.join('&')}`;
};

function baseApi(fullUrl, request) {
  return fetch(fullUrl, request).then(response =>
    response.json().then(json => ({ json, response })),
  ).then(({ json, response }) => {
    if (!response.ok) {
      return Promise.reject(json);
    }

    return json;
  }).then(
    response => ({ response }),
    error => ({ error: error || 'no error message' }),
  );
}

export function callApi(endpoint) {
  const fullUrl = API_ROOT + endpoint;

  const request = {
    credentials: 'same-origin',
  };
  return baseApi(fullUrl, request);
}

export function callUrl(fullUrl) {
  const request = {
    credentials: 'same-origin',
  };
  return baseApi(fullUrl, request);
}

export function sendApi(endpoint, method, data) {
  const fullUrl = API_ROOT + endpoint;

  const request = {
    credentials: 'same-origin',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'X-CSRFToken': getCsrf(),
    },
    method,
    body: JSON.stringify(data),
  };
  return baseApi(fullUrl, request);
}

function uploadApi(endpoint, method, data) {
  const fullUrl = API_ROOT + endpoint;

  const request = {
    credentials: 'same-origin',
    headers: {
      Accept: 'application/json',
      'X-CSRFToken': getCsrf(),
    },
    method,
    body: data,
  };
  return baseApi(fullUrl, request);
}

function apiLogin(username, password) {
  const fullUrl = `${API_ROOT}user/auth/`;

  const request = {
    credentials: 'same-origin',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: `Basic ${window.btoa(`${username}:${password}`)}`,
    },
    method: 'post',
  };
  return baseApi(fullUrl, request);
}

export const fetchCachedChargers = url => callUrl(url);
export const fetchChargersNearIp = () => callApi('chargers_near_ip/?limit=25');
export const fetchChargers = args => callApi(`charger/${processArgs(args)}`);
export const fetchPlaces = args => callApi(`factual-place/${processArgs(args)}`);
export const fetchRankedChargers = () => callApi('charger/?ranking=true&limit=10000');
export const fetchChargerReviews = charger => callApi(`charger/${charger}/reviews/`);
export const fetchChargerImages = charger => callApi(`charger/${charger}/images/`);
export const newChargerReview = (charger, review) => sendApi(
  `charger/${charger}/reviews/`, 'POST', review);
export const submitPlaceReview = (place, review) => sendApi(
  `factual-place/${place}/reviews/`, 'POST', review);
export const fetchPlaceReviews = place => callApi(`factual-place/${place}/reviews/`);
export const fetchChargerPlaces = (charger, args) => {
  const placesArgs = Object.assign({}, args, {
    near_charger: charger,
    radius: args.radius || 1000,
  });
  return fetchPlaces(placesArgs);
};
export const newPlaceUpdate = (place, update) => sendApi(`place/${place}/updates/`, 'POST', update);
export const newPlace = data => sendApi('place/', 'POST', data);

export const fetchUser = username => callApi(`user/${username}/?reviews=true`);
export const fetchUsers = args => callApi(`user/${processArgs(args)}`);
export const fetchCurrentUser = () => callApi('user/__current/');
export const addNewUser = data => sendApi('user/', 'POST', data);
export const patchUser = (username, data) => sendApi(`user/${username}/`, 'PATCH', data);
export const login = (username, password) => apiLogin(username, password);
export const logout = () => sendApi('user/auth/', 'DELETE', {});
export const changePassword = data => sendApi('user/auth/password/change/', 'PUT', data);
export const resetPassword = data => sendApi('user/auth/password/reset/', 'POST', data);

export const fetchCountries = () => callApi('country/');
export const fetchStates = () => callApi('state/');
export const fetchPage = slug => callApi(`page/${slug}/`);
export const submitContactForm = data => sendApi('contact_form/', 'POST', data);

export const uploadUserImage = (username, image) => {
  const data = new FormData();
  data.append('image', image);
  return uploadApi(`user/${username}/image/`, 'PUT', data);
};

export const deleteUserImage = (username) => {
  const data = new FormData();
  return uploadApi(`user/${username}/image/`, 'DELETE', data);
};

export const uploadChargerImage = (charger, data, image) => {
  const formData = new FormData();
  formData.append('data', JSON.stringify(data));
  formData.append('image', image);
  return uploadApi(`charger/${charger}/images/`, 'POST', formData);
};



// WEBPACK FOOTER //
// ./app/scripts/services/api.js